import React, { useState, useEffect } from "react";
import DropDown from "./../components/admin/DropDown";
import InputField from "../components/admin/InputField";
import Button from "../components/UI/Button";
import { Link } from "react-router-dom";
import EditUserList from "../components/admin/EditUserList";
import { useAppContext } from "../context/appContext";

const EditUser = () => {
    const { isLoading, getUsers, displayItems, currentEdit, getUser, updateUser, deleteUser } =
        useAppContext();
    const [firstName, setFirstName] = useState("");
    // const currEditRef = useRef(currentEdit);

    const setFirstNameHandler = (e) => {
        setFirstName(e.target.value);
    };
    const [lastName, setLastName] = useState("");

    const setLastNameHandler = (e) => {
        setLastName(e.target.value);
    };

    const [password, setPassword] = useState("");

    const setPasswordHandler = (e) => {
        setPassword(e.target.value);
    };

    const [dropdownValue, setDropdownValue] = useState("");

    const [userId, setUserId] = useState("");

    const setDropdownValueHandler = (value) => {
        setDropdownValue(value);
    };

    const options = [
        { id: 1, name: "Admin", unavailable: false },
        { id: 2, name: "User", unavailable: false },
    ];

    useEffect(() => {
        getUsers();
    }, []);

    useEffect(() => {
        if (userId) {
            getUser(userId);
        }
    }, [userId]);

    useEffect(() => {
        if (currentEdit._id) {
            const name = currentEdit.name.split(" ");
            setFirstName(name[0]);
            setLastName(name[1]);
            setPassword(currentEdit.password);
            setDropdownValue(currentEdit.role);
        }
    }, [currentEdit]);

    const setUserIdHandler = (id) => {
        setUserId(id);
    };

    const submitHandler = async (e) => {
        e.preventDefault();

        if (!firstName || !lastName || !password || !dropdownValue) {
            return;
        }
        await updateUser(userId, {
            name: `${firstName} ${lastName}`,
            password,
            role: dropdownValue,
        });
        setFirstName("");
        setLastName("");
        setPassword("");
        setDropdownValue("");
        setUserId("");
        getUsers();
    };

    const deleteUserHandler = async (id) => {
        await deleteUser(id);
        getUsers();
    };

    return (
        <div className='flex min-h-[35rem] w-full max-w-[50rem] flex-col rounded-lg bg-main-800'>
            <div className='h-auto w-full rounded-t-lg bg-slate-100 p-4 font-semibold text-main-900'>
                <h1 className='text-2xl  '>
                    Staff Management -{" "}
                    <Link to={"/admin/staff/"}>
                        <span className='cursor-pointer text-xl'> Add user</span>
                    </Link>
                    <Link to={"/admin/staff/edit"}>
                        <span className='mx-1 cursor-pointer rounded-md border-2 border-main-800 bg-main-800 p-1 text-xl text-white'>
                            Edit / Delete user
                        </span>
                    </Link>
                </h1>
            </div>

            <div className='m-8'>
                <EditUserList
                    onEdit={setUserIdHandler}
                    onDelete={deleteUserHandler}
                    users={displayItems}
                />
                <h2 className='mt-4 mb-1 text-2xl'>Edit user </h2>
                <form onSubmit={submitHandler}>
                    <div className='mb-6 grid gap-6 md:grid-cols-2'>
                        <input type='hidden' value={userId} />
                        <InputField
                            type={"text"}
                            name={"First Name"}
                            handleChange={setFirstNameHandler}
                            value={firstName}
                        />
                        <InputField
                            type={"text"}
                            name={"Last Name"}
                            handleChange={setLastNameHandler}
                            value={lastName}
                        />
                    </div>

                    <div className='mb-6'>
                        <InputField
                            type={"text"}
                            name={"Password"}
                            handleChange={setPasswordHandler}
                            value={password}
                        />
                    </div>

                    <div className='max-w-[20rem] pb-4'>
                        <DropDown
                            options={options}
                            name={"User"}
                            onValueChange={setDropdownValueHandler}
                        />
                    </div>

                    <div>
                        <Button label={"Submit"} />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditUser;
